// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"532":"a4e31a4c31a39188099b","678":"2daca6d97816e8ff09ad"}[chunkId] + ".js";
};